const sortScore = (scores) => {
	return scores.sort((s1,s2)=>s2.date-s1.date);
};

const extractGradeByDate = (score) => {
	const dateTime = new Date(score.date);
	const normalizedScore = score.passed / score.questionCount;
	return {
		...score,
		dateTime,
		normalizedScore
	};
};

export {
	sortScore,
	extractGradeByDate
};